import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormInputText, InputLabel } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

import { CustomReportInfo } from '../../../types';

import { SectionHeader } from './CustomReportForm.styles';

interface CustomReportHeaderProps {
  isDeleting: boolean;
  handleOnDelete: (uuid) => void;
}

export const CustomReportHeader: FC<CustomReportHeaderProps> = ({ isDeleting, handleOnDelete }) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext<CustomReportInfo>();
  const uuid = watch('uuid');

  return (
    <SectionHeader>
      <InputLabel>Name</InputLabel>
      <Controller
        control={control}
        name="name"
        defaultValue=""
        render={({ field: { value, onChange } }) => (
          <FormInputText
            variant="outlined"
            name="name"
            value={value}
            fullWidth
            placeholder="Name"
            autoFocus
            error={!!errors.name}
            helperText={errors.name ? errors.name.message : ''}
            onChange={onChange}
          />
        )}
      />

      {uuid && (
        <Button color="destructive" loading={isDeleting} onClick={() => handleOnDelete(uuid)}>
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      )}
    </SectionHeader>
  );
};
